import {
  useOrderFormStore,
  useOrderFormStoreActions,
} from '../../stores/order-form.store'
import { useOrderFormCalculation } from '../../hooks/use-order-form-calculation.hook'
import useOrderFormParams from '../../hooks/use-order-form-params.hook'

export const useOrderFormHeaderComponent = () => {
  const { isCalculatingOrder, calculateOrderForm } =
    useOrderFormCalculation()

  const { jsonOrderForm, paramsLayoutOrderForm, isCalculationOrder } =
    useOrderFormStore()
  const { setIsCalculationOrder } = useOrderFormStoreActions()

	const {autoCalculateEnabled} = useOrderFormParams()

  const handleCalculationOrder = () => {
    setIsCalculationOrder(true)

    calculateOrderForm()
  }

  return {
    jsonOrderForm,
    isCalculationOrder,
    paramsLayoutOrderForm,
    isCalculatingOrder,
    onCalculationOrder: handleCalculationOrder,
		autoCalculateEnabled
  }
}
